import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'invopay/broker/login-broker',
    pathMatch: 'full',
  },
  {
    path: 'invopay',
    redirectTo: 'invopay/broker/login-broker',
    pathMatch: 'full',
  },
  {
    path: 'invopay/broker',
    loadChildren: () =>
      import('./invopay/invopay.module').then((m) => m.InvopayModule),
  },
  {
    path: '**',
    redirectTo: 'invopay/broker/login-broker'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
